import React from 'react';
import Icon, { ICONSIZE } from '../../../../../../../presentation/components/Icon';
import invoiceIcon from '../../../../../../assets/icons/png/3x/icn-abrechnung-fertig@3x-schwarz.png';
import checkmarkIcon from '../../../../../../assets/icons/png/3x/circle-check-info@3x.png';
import TableEntry from '../../TableEntry';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';

const InvoicingAllRenters: React.FC = () => {
  const isAboveXXS = useMediaQuery('(min-width: 376px)');
  const { t } = useTranslation();

  return (
    <TableEntry
      leftValues={[
        t('pageSummaryBasicServicesSectionLabelInvoicingAllRentersTitle'),
        t('pageSummaryBasicServicesSectionLabelInvoicingAllRentersContent')
      ]}
      startElement={<Icon iconSrc={invoiceIcon} size={ICONSIZE.medium} alt="invoice icon" />}
      endElement={
        <Icon iconSrc={checkmarkIcon} size={ICONSIZE.small} centered alt="checkmark icon" />
      }
      additionalClassNames={isAboveXXS ? '' : 'px-0'}
    />
  );
};

export default InvoicingAllRenters;
